export interface AnimeItem {
  id: number;
  title: string;
  category: string;
  tag: string;
  year: number;
  episodes: string;
  rating: number;
  views: string;
  status: string;
  desc: string;
  poster: string;
  banner: string;
  related: number[];
}

export const CATEGORIES = [
  { name: "全部", key: "all", icon: "ri-apps-2-line", desc: "番剧库全收录" },
  { name: "动画番剧", key: "动画", icon: "ri-tv-2-line", desc: "连载与完结全集" },
  { name: "剧场版", key: "剧场版", icon: "ri-film-line", desc: "电影版同步更新" },
  { name: "OVA", key: "OVA", icon: "ri-disc-line", desc: "番外与特别篇" },
  { name: "泡面番", key: "泡面番", icon: "ri-cup-line", desc: "三分钟轻松开播" },
  { name: "国漫", key: "国漫", icon: "ri-quill-pen-line", desc: "国产动画专区" },
];

export const animeList: AnimeItem[] = [
  {
    id: 1,
    title: "星海拾樱",
    category: "动画",
    tag: "青春治愈",
    year: 2025,
    episodes: "全24集",
    rating: 9.6,
    views: "1280万",
    status: "已完结",
    desc: "在樱花纷飞的临海小镇，少女小樱为了追寻消失的星海之光，与伙伴们踏上跨越四季的旅程。细腻的情感、动人的配乐与治愈的画风交织，成为今年最温暖的青春番剧之一。",
    poster: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20young%20girl%20with%20flowing%20hair%20standing%20under%20blooming%20sakura%20trees%20by%20the%20sea%2C%20drifting%20flower%20petals%2C%20soft%20warm%20glow%2C%20stylized%20illustration%2C%20cinematic%20atmosphere&width=480&height=680&seq=sakura-anime-01&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=cinematic%20anime%20panorama%20of%20a%20seaside%20town%20in%20spring%20with%20cherry%20blossoms%20raining%20over%20the%20ocean%2C%20warm%20golden%20sunset%20light%2C%20dreamy%20stylized%20background&width=1600&height=700&seq=sakura-anime-banner-01&orientation=landscape",
    related: [3, 5, 7],
  },
  {
    id: 2,
    title: "云际列车",
    category: "剧场版",
    tag: "奇幻冒险",
    year: 2026,
    episodes: "剧场版",
    rating: 9.4,
    views: "960万",
    status: "热映中",
    desc: "一列穿行于云端的神秘列车，载着不同时空的旅人驶向记忆的尽头。剧场版以精良的画面与宏大的世界观，讲述一场关于告别与重逢的奇幻旅程。",
    poster: "https://readdy.ai/api/search-image?query=anime%20movie%20key%20visual%20of%20a%20glowing%20train%20running%20through%20sea%20of%20clouds%20at%20twilight%2C%20floating%20islands%2C%20starlight%2C%20mystical%20stylized%20illustration&width=480&height=680&seq=sakura-anime-02&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=expansive%20anime%20sky%20cityscape%20with%20a%20luminescent%20train%20gliding%20above%20clouds%2C%20twilight%20gradient%20sky%2C%20stars%2C%20dreamy%20cinematic%20scene&width=1600&height=700&seq=sakura-anime-banner-02&orientation=landscape",
    related: [8, 10, 15],
  },
  {
    id: 3,
    title: "深夜食堂·妖怪篇",
    category: "泡面番",
    tag: "日常美食",
    year: 2025,
    episodes: "全16集",
    rating: 9.1,
    views: "520万",
    status: "已完结",
    desc: "每当夜深人静，妖怪们便会光顾这家藏在巷尾的小食堂。每集三分钟，一道料理、一个妖怪、一段暖心故事，治愈你每一个疲惫的夜晚。",
    poster: "https://readdy.ai/api/search-image?query=cozy%20anime%20illustration%20of%20a%20small%20lantern-lit%20night%20diner%20with%20cute%20spirit%20creatures%20enjoying%20hot%20food%2C%20warm%20glowing%20lights%2C%20stylized%20chibi%20style&width=480&height=680&seq=sakura-anime-03&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=night%20alley%20with%20glowing%20red%20lanterns%20and%20a%20tiny%20cozy%20diner%2C%20anime%20style%2C%20warm%20amber%20atmosphere%2C%20soft%20steam%20rising%20from%20food&width=1600&height=700&seq=sakura-anime-banner-03&orientation=landscape",
    related: [9, 14],
  },
  {
    id: 4,
    title: "长安墨客",
    category: "国漫",
    tag: "古风历史",
    year: 2025,
    episodes: "全36集",
    rating: 9.5,
    views: "2100万",
    status: "连载中",
    desc: "以盛唐长安为舞台，一位无名墨客以笔为剑，在权谋与诗酒之间书写传奇。精美的水墨画风与考究的历史考据，让国漫走向新的高度。",
    poster: "https://readdy.ai/api/search-image?query=chinese%20ink%20wash%20anime%20key%20visual%20of%20a%20scholar%20in%20traditional%20robes%20holding%20a%20calligraphy%20brush%20under%20a%20peach%20tree%2C%20tang%20dynasty%20city%20background%2C%20elegant%20painting%20style&width=480&height=680&seq=sakura-anime-04&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=grand%20ancient%20chinese%20city%20of%20chang-an%20at%20sunset%20with%20rooftops%20and%20flying%20petals%2C%20ink%20painting%20style%2C%20warm%20orange%20and%20gold%20tones&width=1600&height=700&seq=sakura-anime-banner-04&orientation=landscape",
    related: [8, 13, 15],
  },
  {
    id: 5,
    title: "四月是你的樱花",
    category: "动画",
    tag: "音乐恋爱",
    year: 2025,
    episodes: "全22集",
    rating: 9.3,
    views: "880万",
    status: "已完结",
    desc: "以樱花盛开与凋零为喻，讲述两位以音乐为名的少年少女在春天的相遇。每一帧都如诗如画，琴声与花雨交织，谱写出温柔又心动的恋曲。",
    poster: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20boy%20playing%20piano%20in%20a%20room%20filled%20with%20cherry%20blossom%20petals%2C%20violinist%20silhouette%2C%20soft%20spring%20light%2C%20romantic%20stylized%20illustration&width=480&height=680&seq=sakura-anime-05&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=spring%20school%20courtyard%20with%20falling%20cherry%20blossoms%20and%20a%20grand%20piano%20by%20a%20window%2C%20anime%20style%2C%20soft%20pastel%20warm%20lighting&width=1600&height=700&seq=sakura-anime-banner-05&orientation=landscape",
    related: [1, 7, 11],
  },
  {
    id: 6,
    title: "量子游乐园",
    category: "动画",
    tag: "科幻冒险",
    year: 2026,
    episodes: "全12集",
    rating: 8.9,
    views: "460万",
    status: "连载中",
    desc: "当现实世界崩塌，少年少女们坠入由量子算法构建的巨型游乐园。每一个设施都是一道谜题，通关才能重返现实，一场脑洞大开的科幻冒险就此展开。",
    poster: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20neon%20ferris%20wheel%20and%20glowing%20roller%20coaster%20in%20a%20cyber%20amusement%20park%20at%20night%2C%20holographic%20lights%2C%20stylized%20sci-fi%20illustration&width=480&height=680&seq=sakura-anime-06&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=futuristic%20amusement%20park%20at%20dusk%20with%20glowing%20rides%20and%20holograms%2C%20anime%20sci-fi%20scene%2C%20vibrant%20magenta%20and%20gold%20lights&width=1600&height=700&seq=sakura-anime-banner-06&orientation=landscape",
    related: [11, 15, 12],
  },
  {
    id: 7,
    title: "雾隐城物语",
    category: "OVA",
    tag: "和风奇幻",
    year: 2025,
    episodes: "OVA全6话",
    rating: 9.0,
    views: "380万",
    status: "已完结",
    desc: "漂浮在浓雾中的古老城池，收藏着人们遗忘的回忆。OVA特别篇以幽静的笔触，讲述守城者与来访者之间一个个神秘而温柔的故事。",
    poster: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20mysterious%20castle%20shrouded%20in%20fog%20with%20a%20lone%20figure%20holding%20a%20paper%20lantern%2C%20japanese%20fantasy%2C%20soft%20muted%20stylized%20illustration&width=480&height=680&seq=sakura-anime-07&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=foggy%20ancient%20japanese%20castle%20on%20a%20lake%20at%20dawn%2C%20misty%20atmosphere%2C%20paper%20lanterns%20floating%2C%20anime%20style%20muted%20tones&width=1600&height=700&seq=sakura-anime-banner-07&orientation=landscape",
    related: [3, 5, 12],
  },
  {
    id: 8,
    title: "山海绘卷",
    category: "国漫",
    tag: "神话史诗",
    year: 2026,
    episodes: "剧场版",
    rating: 9.4,
    views: "1500万",
    status: "热映中",
    desc: "以《山海经》为蓝本打造的国风奇幻剧场版，异兽横行的大荒世界中，少年祭司唤醒沉睡的绘卷，展开一场守护山海的神话史诗。",
    poster: "https://readdy.ai/api/search-image?query=chinese%20mythological%20anime%20key%20visual%20of%20a%20young%20priest%20with%20a%20giant%20mythical%20beast%20behind%20him%2C%20clouds%20and%20mountains%2C%20vibrant%20traditional%20colors%2C%20epic%20painting%20style&width=480&height=680&seq=sakura-anime-08&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=epic%20chinese%20mythological%20landscape%20with%20soaring%20phoenix%20and%20clouds%20over%20misty%20mountains%2C%20traditional%20ink%20and%20gold%2C%20grand%20scale&width=1600&height=700&seq=sakura-anime-banner-08&orientation=landscape",
    related: [4, 13, 2],
  },
  {
    id: 9,
    title: "喵喵茶会",
    category: "泡面番",
    tag: "萌系日常",
    year: 2025,
    episodes: "全24集",
    rating: 8.8,
    views: "420万",
    status: "已完结",
    desc: "一群会说话的小猫经营着一家神奇的下午茶店。每集三分钟的软萌日常，萌到融化，是适合放松心情的下饭泡面番。",
    poster: "https://readdy.ai/api/search-image?query=adorable%20anime%20chibi%20cats%20wearing%20tiny%20aprons%20serving%20tea%20and%20cakes%20at%20a%20cute%20pastel%20cafe%2C%20kawaii%20style%20illustration%2C%20soft%20warm%20colors&width=480&height=680&seq=sakura-anime-09&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=cozy%20pastel%20cat%20cafe%20interior%20with%20cakes%20tea%20and%20cute%20cat%20staff%2C%20anime%20chibi%20style%2C%20warm%20and%20playful%20atmosphere&width=1600&height=700&seq=sakura-anime-banner-09&orientation=landscape",
    related: [3, 14],
  },
  {
    id: 10,
    title: "风之回廊",
    category: "剧场版",
    tag: "成长治愈",
    year: 2025,
    episodes: "剧场版",
    rating: 9.2,
    views: "720万",
    status: "已完结",
    desc: "少年在一次风暴后闯入被风守护的秘境回廊，与守风人相遇。剧场版以通透的画面和安静的叙事，讲述勇气、自由与成长的故事。",
    poster: "https://readdy.ai/api/search-image?query=anime%20movie%20key%20visual%20of%20a%20boy%20standing%20in%20a%20grassland%20corridor%20with%20swirling%20wind%20and%20dandelion%20seeds%2C%20bright%20sky%2C%20refreshing%20stylized%20illustration&width=480&height=680&seq=sakura-anime-10&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=vast%20green%20grassland%20with%20spiraling%20wind%20patterns%20and%20floating%20seeds%20under%20a%20clear%20blue%20sky%2C%20anime%20style%2C%20fresh%20and%20airy&width=1600&height=700&seq=sakura-anime-banner-10&orientation=landscape",
    related: [2, 1, 15],
  },
  {
    id: 11,
    title: "机甲燃星",
    category: "动画",
    tag: "热血机甲",
    year: 2026,
    episodes: "全13集",
    rating: 9.0,
    views: "1100万",
    status: "连载中",
    desc: "人类在星际边境与未知机械生命作战，少年驾驶员驾驶传说中的机体「燃星」，在一次次生死对决中觉醒。燃到极致的机甲热血番。",
    poster: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20crimson%20mecha%20robot%20kneeling%20in%20a%20space%20harbor%20with%20flames%20and%20sparks%2C%20sci-fi%20battle%2C%20dramatic%20stylized%20illustration&width=480&height=680&seq=sakura-anime-11&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=giant%20mecha%20rising%20from%20flames%20in%20a%20space%20dock%20at%20night%2C%20orange%20fire%20and%20metal%20reflections%2C%20anime%20sci-fi%20battle%20scene&width=1600&height=700&seq=sakura-anime-banner-11&orientation=landscape",
    related: [6, 15, 12],
  },
  {
    id: 12,
    title: "百鬼夜行记",
    category: "OVA",
    tag: "志怪冒险",
    year: 2025,
    episodes: "OVA全4话",
    rating: 8.9,
    views: "290万",
    status: "已完结",
    desc: "在妖怪横行的平安时代，除妖师少女与一只傲娇的狐妖组队闯荡。OVA以轻快的节奏讲述一个个奇趣志怪故事，画风精致华丽。",
    poster: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20girl%20exorcist%20with%20a%20white%20fox%20spirit%20in%20ancient%20japan%20at%20night%2C%20floating%20spirits%20and%20lanterns%2C%20stylized%20fantasy%20illustration&width=480&height=680&seq=sakura-anime-12&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=nocturnal%20ancient%20kyoto%20street%20with%20ghosts%20and%20lanterns%20during%20a%20parade%2C%20anime%20style%2C%20moody%20warm%20and%20teal%20lighting&width=1600&height=700&seq=sakura-anime-banner-12&orientation=landscape",
    related: [7, 3, 6],
  },
  {
    id: 13,
    title: "江南小食光",
    category: "国漫",
    tag: "美食日常",
    year: 2025,
    episodes: "全20集",
    rating: 9.1,
    views: "680万",
    status: "已完结",
    desc: "烟雨江南的巷弄里，一对祖孙守着百年老字号小吃铺。每一道苏式点心背后，都是关于家乡与传承的温暖故事。水墨质感下的国漫美食日常。",
    poster: "https://readdy.ai/api/search-image?query=chinese%20anime%20key%20visual%20of%20an%20elderly%20grandmother%20and%20grandchild%20making%20traditional%20jiangnan%20sweets%20in%20a%20old%20kitchen%2C%20steam%2C%20warm%20family%20atmosphere%2C%20watercolor%20style&width=480&height=680&seq=sakura-anime-13&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=old%20jiangnan%20water%20town%20alley%20with%20a%20traditional%20snack%20shop%20and%20umbrellas%20in%20the%20rain%2C%20chinese%20watercolor%20anime%20style%2C%20soft%20muted%20tones&width=1600&height=700&seq=sakura-anime-banner-13&orientation=landscape",
    related: [4, 8, 9],
  },
  {
    id: 14,
    title: "黄昏书店",
    category: "泡面番",
    tag: "奇幻书店",
    year: 2026,
    episodes: "全12集",
    rating: 8.7,
    views: "210万",
    status: "连载中",
    desc: "只在黄昏时分营业的神秘书店，能读到每个人心中最想看到的故事。三分钟一集，温暖又治愈，像一杯刚泡好的热茶。",
    poster: "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20cozy%20bookstore%20lit%20by%20warm%20lamps%20during%20golden%20hour%2C%20floating%20books%20and%20dust%20motes%2C%20dreamy%20stylized%20scene&width=480&height=680&seq=sakura-anime-14&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=golden%20hour%20street%20with%20a%20glowing%20old%20bookstore%20and%20flying%20pages%2C%20anime%20style%2C%20warm%20nostalgic%20atmosphere&width=1600&height=700&seq=sakura-anime-banner-14&orientation=landscape",
    related: [9, 3],
  },
  {
    id: 15,
    title: "星穹航海团",
    category: "动画",
    tag: "热血冒险",
    year: 2026,
    episodes: "全26集",
    rating: 9.3,
    views: "1340万",
    status: "连载中",
    desc: "在星海纵横的航海时代，一支由落魄少年组成的团队踏上寻找「星之终点」的伟大航路。友情、热血与梦想，是今年不容错过的冒险长篇。",
    poster: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20crew%20of%20young%20adventurers%20on%20a%20ship%20sailing%20toward%20a%20giant%20glowing%20star%20in%20space%2C%20adventure%20stylized%20illustration&width=480&height=680&seq=sakura-anime-15&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=fantasy%20space%20ocean%20with%20a%20sailing%20ship%20navigating%20between%20glowing%20stars%20and%20nebula%2C%20anime%20adventure%20scene%2C%20vibrant%20colors&width=1600&height=700&seq=sakura-anime-banner-15&orientation=landscape",
    related: [2, 11, 6],
  },
  {
    id: 16,
    title: "指尖的魔法",
    category: "动画",
    tag: "奇幻日常",
    year: 2025,
    episodes: "全18集",
    rating: 9.2,
    views: "590万",
    status: "已完结",
    desc: "一位能凭指尖感知他人心情的少女，在魔法学院里帮助每一位迷路的同学。轻甜治愈的日常奇幻，画风明亮温暖，令人会心一笑。",
    poster: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20girl%20with%20glowing%20fingertips%20in%20a%20magic%20academy%20surrounded%20by%20sparkles%2C%20light%20pastel%20palette%2C%20gentle%20stylized%20illustration&width=480&height=680&seq=sakura-anime-16&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=magic%20academy%20courtyard%20with%20floating%20sparkles%20and%20glowing%20runes%2C%20anime%20style%2C%20soft%20pastel%20and%20warm%20golden%20lighting&width=1600&height=700&seq=sakura-anime-banner-16&orientation=landscape",
    related: [1, 5, 3],
  },
];

export const CATEGORY_HERO: Record<string, { title: string; desc: string; image: string }> = {
  动画: {
    title: "动画番剧",
    desc: "连载新番与经典完结番一网打尽，点开即看全集。",
    image: "https://readdy.ai/api/search-image?query=anime%20collage%20of%20various%20series%20scenes%20in%20a%20warm%20cinematic%20style%2C%20sunset%20tones%2C%20stylized%20background&width=1600&height=600&seq=cat-hero-anime&orientation=landscape",
  },
  剧场版: {
    title: "剧场版",
    desc: "人气动画电影同步更新，大银幕级别的观感在线呈现。",
    image: "https://readdy.ai/api/search-image?query=cinematic%20movie%20reel%20and%20popcorn%20with%20glowing%20film%20projection%2C%20warm%20theater%20atmosphere%2C%20stylized%20illustration&width=1600&height=600&seq=cat-hero-movie&orientation=landscape",
  },
  OVA: {
    title: "OVA 特别篇",
    desc: "番外篇、特别篇与未公开章节，补全你的追番版图。",
    image: "https://readdy.ai/api/search-image?query=mysterious%20disc%20and%20ribbon%20in%20a%20misty%20room%2C%20limited%20edition%20mood%2C%20warm%20and%20moody%20stylized%20illustration&width=1600&height=600&seq=cat-hero-ova&orientation=landscape",
  },
  泡面番: {
    title: "泡面番",
    desc: "三分钟一集的轻松日常，等泡面的时间刚好看完一集。",
    image: "https://readdy.ai/api/search-image?query=cute%20small%20bowls%20and%20mini%20screens%20with%20fun%20cartoon%20frames%2C%20playful%20warm%20colors%2C%20stylized%20illustration&width=1600&height=600&seq=cat-hero-short&orientation=landscape",
  },
  国漫: {
    title: "国漫专区",
    desc: "国产动画崛起之作，水墨质感与热血题材并存。",
    image: "https://readdy.ai/api/search-image?query=chinese%20ink%20painting%20with%20a%20dragon%20and%20calligraphy%20brushes%2C%20traditional%20red%20and%20gold%20accents%2C%20stylized%20illustration&width=1600&height=600&seq=cat-hero-guoman&orientation=landscape",
  },
};

export const getAnimeById = (id: number): AnimeItem | undefined =>
  animeList.find((a) => a.id === id);